import React from "react"
import HeadingM from "../shared/HeadingM"
import ContactOtherBase from "../shared/contact/ContactOther"
import { Target } from "../../utils"

const ContactOther = () => {
  const data = {
    target: "sutea" as Target,
    tel: "048-598-4075",
    openingHour:
      "通常 (月〜金) 9:30〜18:30\n長期休み、土曜日 (春・夏・冬休みなど) 9:00〜18:00",
    lineId: "@137esgni",
    addFriendLink: "4PgxwLJ",
    fax: "048-598-4076",
    email: "sutea@noone.jp",
    instagram: "sutea202504",
  }
  return (
    <>
      <HeadingM title="その他" target="sutea" />
      <ContactOtherBase {...data} />
    </>
  )
}

export default ContactOther
